const __request = require(`./__request`);
/**
 * 取消订单
 */
export default function (val) {
    var pParameter = {}
    pParameter.method = "POST"
    // pParameter.urlSuffix = "/hotel/manager/order/cancelOrderSubmit"

    pParameter.urlSuffix = "/hotel/baseOrder/cancelOrderSubmit"
    pParameter.data = val
    return new Promise(function (resolve, reject) {
        resolve(__request(pParameter))
    })
}
